export default "__VITE_ASSET__CdGUKNiY__"